import React from 'react';

import { Container, Titulo, Box, Mensagem } from './styles';

const ImportantBox = ({ children = '' }) => (
  <Container>
    <Titulo>Importante:</Titulo>

    <Box>
      <Mensagem>{children}</Mensagem>
    </Box>
  </Container>
);

export default ImportantBox;
